export default __webpack_public_path__ + "41a096040b190d1be0f0d6bc47b54f54.png";